<template lang="pug">
  div
    .visual-title.-xs.-white(:style="`background-image: url(https://cdn.taberutokurasuto.com/image/shop/item/list/withinyear.jpg);`")
      .title
        i.h1rem
          LogoYaneSvg
        h1.heading2 年内お届け可能商品
        .heading3.curve-bottom SHIPMENT WITHIN THE YEAR
    .archives-description
      p
        | 年末年始のご馳走やお正月用品や贈り物など、ご準備はお済みでしょうか？
        br
        | 買い忘れた日常品も、これから準備するお年賀も、年内にお届け可能な美味しい商品をまだまだお選びいただけます。
        | 年の締めくくりと始まりにぴったりな商品を見つけてください。

    ItemFilterBlock
      DropDown(@change="$_changeOrder" v-model="pageInfo.orderBy" :options="$_orderDropDownOptions")
      .stock-checkbok
        FormCheckbox(@change="$_changeStockFilter" v-model="stockOnly") 販売中のみ表示

    ItemCardList
      .item.lg(v-for="(itemGroup, index) in itemGroups" :key="itemGroup.id")
        ItemCard(:itemGroup="itemGroup" eventCategory="年内お届け可能商品一覧" pageContents="商品一覧")
    .row
      .col-xs-12(v-if="itemGroups.length === 0")
        .success-notice
          .text-center 商品がありません。
      .col-xs-12
        Pager(@change="$_changePage" :custom-page-info="$_customPageInfo")

    SectionItemArchive

</template>

<script>
  import {GetItemGroupsForApi} from "../../graphqls/ItemGroups";

  import LogoYaneSvg from "../../components/svg/LogoYaneSvg";
  import GlobalMixin from "../../mixin/GlobalMixin";
  import Pager from "../../components/paginate/Pager";
  import DropDown from "../../components/dropdown/DropDown";
  import ItemListMixin from "../../mixin/ItemListMixin";
  import ItemCardList from "../../components/v1/item/ItemCardList";
  import ItemCard from "../../components/v1/item/ItemCardForApi";
  import SectionItemArchive from "../../components/v1/section/SectionItemArchive";
  import ItemFilterBlock from "../../components/v1/item/ItemFilterBlock";
  import FormCheckbox from "../../components/v1/form/FormCheckbox";

  export default {
    name: "WithInYear",
    mixins: [GlobalMixin, ItemListMixin],
    components: {
      FormCheckbox,
      ItemFilterBlock,
      SectionItemArchive,
      DropDown,
      Pager,
      ItemCardList,
      ItemCard,
      LogoYaneSvg
    },
    props: [],
    data() {
      return {
        itemGroups: [],
        pageInfo: {
          currentPage:  Number(this.$route.params.page || 1),
          totalCount: 0,
          perPage: 48,
          orderBy: this.$route.query.order || 'popular'
        },
        stockFilter: this.$route.query.stock || 'instock',
        firstItemGroup: {ogpImageUrl: ''}
      }
    },
    computed: {
      titleBgImage() {
        if (this.firstItemGroup.ogpImageUrl) {
          return this.firstItemGroup.ogpImageUrl
        } else {
          return ''
        }
      },
      topRouterName() {
        return 'within-year-items-index'
      },
      pageRouterName() {
        return 'within-year-items-page-index'
      }
    },
    mounted() {
      this.fetchItemGroups()
    },
    methods: {
      async fetchItemGroups() {
        this.loadingStart();
        const { data } = await this.$apollo
        .query({
          query: GetItemGroupsForApi,
          variables: {
            withinYearItem: true,
            stockFilter: this.stockFilter,
            ...this.pageInfo
          },
          client: 'apiClient'
        })
        .catch(error => {
          this.loadingStop()
          return;
        });
        this.itemGroups = data.itemGroups.items;
        this.pageInfo = data.itemGroups.pageInfo
        this.loadingStop();
        this.$_gaSendViewItemList(this.itemGroups, 'shops/items/within_year', this.pageInfo)
      },
      updateItemGroup(newItemGroup) {
        if (this.itemGroups[0].id === newItemGroup.id) {
          this.firstItemGroup = newItemGroup
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
